import { render, staticRenderFns } from "./InfoTour.vue?vue&type=template&id=50f16ebe&"
import script from "./InfoTour.vue?vue&type=script&lang=js&"
export * from "./InfoTour.vue?vue&type=script&lang=js&"
import style0 from "./InfoTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports